/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_EllipsisInputs */

const en_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Ellipsis`)
};

const fr_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer des points de suspension`)
};

const de_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslassungspunkte einfügen`)
};

const it_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci ellissi`)
};

const ru_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить многоточие`)
};

const es_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar puntos suspensivos`)
};

const zh_cn2_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入省略号`)
};

const ja_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`省略記号を挿入`)
};

const hi_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दीर्घवृत्त डालें`)
};

const pt_pt2_shortcut_keys_name_insert_ellipsis = /** @type {(inputs: Shortcut_Keys_Name_Insert_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir reticências`)
};

/**
* | output |
* | --- |
* | "Insert Ellipsis" |
*
* @param {Shortcut_Keys_Name_Insert_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_ellipsis = /** @type {((inputs?: Shortcut_Keys_Name_Insert_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "de") return de_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "it") return it_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "es") return es_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_insert_ellipsis(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_insert_ellipsis(inputs)
	return en_shortcut_keys_name_insert_ellipsis(inputs)
});